<template>
  <b-table
    hover
    class="table-review"
    sort-by="startDate"
    :busy="groupStore.loading"
    :items="review.intervalList"
    :fields="computedFields()"
  >
    <template #table-busy>
      <div class="text-center my-2 primary-color">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <template #cell(state)="row">
      <multi-select-states
        :interval="row.item"
        :startedReview="true"
        :state="intervalState(row.item)"
        :isDisable="review.isCancel || !notYetStarted(review)"
        @reloadIntervalTable="reloadIntervalTable"
      />
    </template>
    <template #cell(assistants)="row">
      <span v-if="userStore.isStudent">
        {{
          $t("reviews.intervals.vacancies", { vacancies: vacancies(row.item) })
        }}
      </span>
      <ul v-if="userStore.isAdmin || userStore.isTutor" class="signup-list">
        <li
          v-if="getSubscritionsOfreviewParticipants(row.item.id).length == 0"
          class="signup-init"
          @drop="dropIn($event, null, row.item, null)"
          @dragenter.prevent
          @dragover.prevent
        >
          <div></div>
        </li>
        <li
          v-for="signup in getSubscritionsOfreviewParticipants(row.item.id)"
          v-bind:key="signup.id"
          @drop="dropIn($event, null, row.item, index)"
          @dragenter.prevent
          @dragover.prevent
        >
          <div
            class="signup-item"
            :draggable="userStore.isAdmin && notYetStarted(review)"
            @dragstart="startDrag($event, signup, null)"
            @dragend="endDrag($event)"
          >
            <div class="signup-item-content">
              <p class="truncate-text text-white">
                {{ signup.userName }}
              </p>
              <b-button size="sm" variant="light" :disabled="userStore.isTutor"
                ><b-icon-x-circle
                  class="text-white"
                  scale="1"
                  @click="dropSignupUser(row.item, signup)"
                ></b-icon-x-circle>
              </b-button>
            </div>
          </div>
        </li>
      </ul>
    </template>
    <template #cell(waitingList)="row">
      <span v-if="userStore.isStudent && review.waitingList"
        >{{
          signupsInWaitingList(row.item) != 0
            ? signupsInWaitingList(row.item) +
              " " +
              $t("reviews.waitingList.exits")
            : $t("reviews.waitingList.empty")
        }}
      </span>
      <span v-if="!review.waitingList"
        >{{ $t("reviews.waitingList.notApply") }}
      </span>
      <ul
        v-if="(userStore.isAdmin || userStore.isTutor) && review.waitingList"
        class="signup-list"
      >
        <li
          v-for="(signup, index) in getSubscritionsOfreviewWaitList(
            row.item.id
          )"
          :key="signup.id"
          :id="'signupwl-' + index"
          class="drop"
          @drop="dropIn($event, signup, row.item, index)"
          @dragenter.prevent
          @dragleave="leaveWlist($event, index)"
          @dragover="enterWlist($event, index)"
        >
          <div
            class="signup-item"
            :draggable="userStore.isAdmin && notYetStarted(review)"
            @dragend="endDrag($event)"
            @dragstart="startDrag($event, signup, index)"
          >
            <div class="signup-item-content">
              <p class="truncate-text">
                {{ signup.userName }}
              </p>
              <b-button size="sm" variant="light" :disabled="userStore.isTutor"
                ><b-icon-x
                  scale="1"
                  @click="dropSignupUser(row.item, signup)"
                ></b-icon-x>
              </b-button>
            </div>
          </div>
        </li>
      </ul>
    </template>
    <template #cell(SignupState)="row">
      <div
        v-if="
          getSubscribeOfUser(row.item.id) &&
          !isSubscribeOfUserInWaitingList(row.item)
        "
      >
        <p>{{ $t("reviews.signup.registered") }}</p>
      </div>
      <div v-if="isSubscribeOfUserInWaitingList(row.item)">
        <p>{{ $t("reviews.signup.waitingList") }}</p>
      </div>
      <div v-if="!getSubscribeOfUser(row.item.id)">
        <p>{{ $t("reviews.signup.not-registered") }}</p>
      </div>
    </template>
    <template #cell(signup-acction)="row">
      <div
        v-if="userStore.isAdmin && !hasEnded(review)"
        v-show="isActiveInterval(row.item)"
      >
        <button
          v-b-modal="'add-user-' + row.item.id"
          class="add-user-buttom"
          :disabled="
            fullInterval(row.item) ||
            !isSubcribePeriod(review) ||
            review.isCancel
          "
        >
          <span>
            <b-icon-plus-circle></b-icon-plus-circle>
          </span>
          <p class="add-user-text">
            {{ $t("reviews.signup.add-user") }}
          </p>
        </button>

        <b-modal
          :id="'add-user-' + row.item.id"
          header-class="user-modal-header "
          footer-class="user-modal-footer"
          body-class="user-modal-body"
          @ok="singupAll(row.item)"
        >
          <template #modal-header="{ cancel }">
            <div class="user-modal-header ">
              <button
                type="button"
                class="d-flex justify-content-center align-content-center"
                @click="cancel()"
                aria-label="Cerrar"
              >
                <span style="margin-right: 10px">Cerrar</span>
                <i class="isax isax-close-circle"></i>
              </button>
            </div>
          </template>

          <h2
            style="
              font-weight: 400;
              font-size: 18px;
              line-height: 22px;
              margin-bottom: 20px;
            "
          >
            {{ $t("reviews.signup.add-user") }}
          </h2>
          <label style="font-weight: 400; font-size: 16px; line-height: 20px">{{
            $t("reviews.intervals.modal-title")
          }}</label>
          <multi-select-user
            :review="review"
            :item="row.item"
            :limitParticipants="limitOfParticipantMethod(review)"
            :usersLoading="groupStore.loading"
            :numOfSignups="numOfSignupsInInterval(row.item.id)"
            :options_users="options_users"
            :fullList="fullInterval(row.item)"
            @addSelect="addSelect"
          >
          </multi-select-user>
          <template #modal-footer="{ ok, cancel }">
            <button class="button secondary cancel-button" @click="cancel()">
              {{ $t("buttons.close") }}
            </button>
            <button class="button save-button" @click="ok()">
              {{ $t("buttons.addStudentes") }}
            </button>
          </template>
        </b-modal>
      </div>
      <div
        v-if="!userStore.isAdmin"
        v-show="isActiveInterval(row.item)"
        class="signup-button"
      >
        <button
          class="button save-button"
          v-if="!getSubscribeOfUser(row.item.id) && !hasEnded(review)"
          :disabled="
            review.isCancel ||
            userIsSubscribe ||
            !isSubcribePeriod(review) ||
            (fullInterval(row.item) && !review.waitingList)
          "
          @click="signup(row.item, user)"
          v-show="!loading"
        >
          {{
            !fullInterval(row.item)
              ? $t("reviews.signup.join")
              : $t("reviews.signup.join-wl")
          }}
        </button>
        <button
          class="button drop-signup-button"
          v-if="getSubscribeOfUser(row.item.id) && !hasEnded(review)"
          @click="dropSignup(row.item)"
          v-show="!loading"
        >
          {{ $t("reviews.signup.detach") }}
        </button>
      </div>
    </template>
  </b-table>
</template>
<script>
import jwtMixin from "@/mixins/jwtMixin";
import utilitiesMixin from "@/mixins/utilitiesMixin";
import ServiceSignup from "@/service/signup.js";
import useUserState from "@/store/userState";
import useGroupState from "@/store/groupState.js";
import {
  BIconXCircle,
  BIconPlusCircleFill,
  BIconPlusCircle,
} from "bootstrap-vue";
import multiSelectUser from "@/components/Lti/CustomElements/multiSelectUser.vue";
import multiSelectStates from "@/components/Lti/CustomElements/multiSelectStates.vue";
import i18n from "@/i18n";

export default {
  components: {
    multiSelectUser,
    multiSelectStates,
    BIconXCircle,
    BIconPlusCircleFill,
    BIconPlusCircle,
  },
  name: "IntervalTable",
  mixins: [jwtMixin, utilitiesMixin],
  props: ["review"],
  async created() {
    this.user = this.jwtLoggedUserId();
    await this.getSignupListIntervalsOfReview(this.review.intervalList);
  },
  data() {
    return {
      userStore: useUserState(),
      groupStore: useGroupState(),
      loading: false,
      userIsSubscribe: false,
      user: null,
      reload: false,
      key: 1,
      signupUser: null,
      startSignupDrag: null,
      targetSignup: null,
      selected_users: [],
      signupsOfUser: [],
      signupListReviews: [],
      signupListReviewsWaitList: [],
      fields: [
        {
          key: "startDate",
          label: i18n.t("reviews.intervals.start"),
          formatter: (value) => {
            return window.moment(value).format("D/M/YY HH:mm");
          },
          sortable: true,
          class: "text-left align-middle col-1",
        },
        {
          key: "endDate",
          label: i18n.t("reviews.intervals.end"),
          formatter: (value) => {
            return window.moment(value).format("D/M/YY HH:mm");
          },
          class: "text-left align-middle col-1",
        },
        {
          key: "state",
          label: i18n.t("reviews.intervals.states"),
          class: "text-left align-middle state-col",
        },
        {
          key: "assistants",
          label: `${i18n.t(
            "reviews.intervals.assistants"
          )} (max ${this.limitOfParticipantMethod(this.review)})`,
          class: "text-left align-middle",
        },
        {
          key: "waitingList",
          label: i18n.t("reviews.intervals.waitingList"),
          class: "text-left align-middle",
        },
        {
          key: "SignupState",
          label: i18n.t("reviews.signup.state"),
          class: "text-left align-middle col-1",
          onlyUsers: true,
          tutorOff: true,
        },
        {
          key: "signup-acction",
          label: i18n.t("reviews.intervals.assistantsSignup"),
          class: "text-left align-middle signup-col",
          tdClass: "p-0",
          tutorOff: true,
        },
      ],
    };
  },
  methods: {
    async singupAll(item) {
      this.groupStore.loading = true;
      this.selected_users.forEach((us) => {
        let newSignup = {
          intervalId: item.id,
          userId: us.unirId,
          lmsUserId: us.lmsUserId,
          userEmail: us.contactEmail,
          waitingList: false,
          orderInInterval: 0,
          attended: true,
          comment: null,
        };
        ServiceSignup.postSignup(null, item.id, newSignup)
          .then((response) => {
            console.log("response", response);
            if (response.status === 201) {
              this.$noty.success(this.$t("noty.success.signup") + us.fullName, {
                timeout: 1500,
                progressBar: true,
              });
              if (!response.data.calendarEventId) {
                this.$noty.error(this.$t("noty.error.calendar-event"), {
                  timeout: 3000,
                  progressBar: true,
                });
              }
            }
          })
          .catch((error) => {
            console.log("error", { error });
            this.$noty.error(this.$t("noty.error.signup"), {
              timeout: 3000,
              progressBar: true,
            });
          })
          .finally(() => {
            this.selected_users = [];
            this.reload = true;
            this.wait();
            this.groupStore.loading = false;
          });
      });
    },
    async signup(item, user) {
      // create a singup (Inscribirse en un intervalo)
      let newSignup;
      if (user == this.user) {
        // El propio usuario se inscribe
        newSignup = {
          intervalId: item.id,
          userId: this.userStore.unirId,
          lmsUserId: this.userStore.lmsUserId,
          userEmail: this.userStore.email,
          waitingList: true,
          orderInInterval: 0,
          attended: true,
          comment: null,
        };
      } else {
        // el usuario es inscrito por un porfesor
        newSignup = {
          intervalId: item.id,
          userId: user.unirId,
          lmsUserId: user.lmsUserId,
          userEmail: user.contactEmail,
          waitingList: true,
          orderInInterval: 0,
          attended: true,
          comment: null,
        };
      }
      this.groupStore.loading = true;
      await ServiceSignup.postSignup(null, item.id, newSignup)
        .then((response) => {
          if (response.status === 200) {
            console.log("response body", response);
            if (!response.data.waitingList) {
              this.signupListReviewsWaitList =
                this.signupListReviewsWaitList.filter(
                  (signup) =>
                    !(
                      signup.userUnirId == response.data.userId &&
                      signup.waitingList
                    )
                );
            }
            this.reload = true;
          }
          this.$noty.success(this.$t("noty.success.signup"), {
            timeout: 3000,
            progressBar: true,
          });
        })
        .catch((error) => {
          this.$noty.error(this.$t("noty.error.signup"), {
            timeout: 3000,
            progressBar: true,
          });
        })
        .finally(() => {
          this.groupStore.loading = false;
          this.wait();
        });
    },
    dropSignup(_item) {
      this.dropSignupUser(_item, null);
    },
    async dropSignupUser(item, singup) {
      // si ya ha empezado no hacer nada y avisar que no se puede
      if (!this.notYetStarted(this.review)) {
        this.$noty.error(this.$t("noty.error.not-delete"), {
          timeout: 3000,
          progressBar: true,
        });
        return;
      }
      // Método para desincribirse de un Intervalo
      this.groupStore.loading = true;
      if (singup) {
        await ServiceSignup.deleteSignup(
          null,
          item.id,
          singup.id,
          singup.lmsUserId
        )
          .then((response) => {
            if (response && response.status === 200)
              this.userIsSubscribe = false;
          })
          .finally(() => {
            this.groupStore.loading = false;
            this.wait();
          });
      } else {
        let userSignup = [];
        let userId = this.userStore.unirId;
        let toDeleteSignup = null;
        await ServiceSignup.getSignup(null, item.id)
          .then((response) => {
            userSignup = response.data;
          })
          .finally(() => {
            userSignup.forEach((signup) => {
              if (signup.userId == userId) toDeleteSignup = signup;
            });
            if (toDeleteSignup != null) {
              ServiceSignup.deleteSignup(null, item.id, toDeleteSignup.id).then(
                (response) => {
                  if (response && response.status === 200)
                    this.userIsSubscribe = false;
                }
              );
            }
            this.groupStore.loading = false;
            this.wait();
          });
      }
      this.$noty.success(this.$t("noty.success.delete"), {
        timeout: 3000,
        progressBar: true,
      });
      this.wait();
    },
    async getSignupListIntervalsOfReview(intervalList) {
      this.loading = true;
      this.signupsOfUser = [];
      this.signupListReviews = [];
      this.signupListReviewsWaitList = [];
      const callOfInterval = (interval) =>
        ServiceSignup.getSignup(null, interval.id);
      const getCallOfInterval = async (interval) => {
        const result = await callOfInterval(interval);
        return result;
      };
      const intervalListLoop = async () => {
        for (const interval of intervalList) {
          let intervalSubscribe = false;
          let vueComponent = this;
          const outresp = await getCallOfInterval(interval);
          outresp.data.forEach((signup) => {
            let signupUserData = {
              id: signup.id,
              intervalId: interval.id,
              userName: signup.userName,
              userUnirId: signup.userId,
              orderInInterval: signup.orderInInterval,
              waitingList: signup.waitingList,
            };
            if (signup.waitingList) {
              vueComponent.signupListReviewsWaitList.push(signupUserData);
            } else {
              vueComponent.signupListReviews.push(signupUserData);
            }
            if (signup.userId == this.userStore.unirId) {
              intervalSubscribe = true;
              if (!signup.waitingList) this.userIsSubscribe = true;
            }
          });
          let signupUser = {
            intervalId: interval.id,
            isSubscribe: intervalSubscribe,
          };
          if (Array.isArray(this.signupsOfUser))
            vueComponent.signupsOfUser.push(signupUser);
        }
      };
      await intervalListLoop();
      this.loading = false;
    },
    getSubscribeOfUser(item) {
      if (
        this.signupsOfUser.length === 0 ||
        this.signupsOfUser.filter(function (element) {
          return element.intervalId === item;
        })[0] === undefined
      ) {
        return false;
      } else {
        return this.signupsOfUser.filter(function (element) {
          return element.intervalId === item;
        })[0].isSubscribe;
      }
    },
    isSubscribeOfUserInWaitingList(item) {
      return this.getSubscritionsOfreviewWaitList(item.id).some(
        (signup) => signup.userUnirId == this.userStore.unirId
      );
    },
    getSubscritionsOfreviewParticipants(item) {
      return this.signupListReviews
        .filter(function (element) {
          return element.intervalId === item;
        })
        .sort(function (a, b) {
          return a.orderInInterval - b.orderInInterval;
        });
    },
    getSubscritionsOfreviewWaitList(item) {
      return this.signupListReviewsWaitList
        .filter(function (element) {
          return element.intervalId === item;
        })
        .sort(function (a, b) {
          return a.orderInInterval - b.orderInInterval;
        });
    },
    getSubscritionsOfReview() {
      return this.signupListReviews.concat(this.signupListReviewsWaitList);
    },
    wait() {
      setTimeout(() => {
        this.reload = true;
      }, 400);
    },
    userSignup(item) {
      try {
        ServiceSignup.getSignup(null, item.id).then((response) => {
          return response.data;
        });
      } catch (err) {
        console.log(err);
      }
    },
    upSignupWaitingList(item, singup) {
      singup.orderInInterval -= 1;
      ServiceSignup.putSignup(null, item.id, singup.id, singup).then(
        (response) => {
          if (response.status === 200) this.reload = true;
        }
      );
    },
    downSignupWaitingList(item, singup) {
      singup.orderInInterval += 1;
      ServiceSignup.putSignup(null, item.id, singup.id, singup).then(
        (response) => {
          if (response.status === 200) this.reload = true;
        }
      );
    },
    async reloadIntervalTable() {
      this.$emit("refreshtable");
      this.$forceUpdate();
    },
    isActiveInterval(interval) {
      return this.intervalState(interval) == "active";
    },
    signupsInInterval(interval) {
      let size = this.signupListReviews.filter(
        (sig) => sig.intervalId == interval.id
      ).length;
      return size;
    },
    signupsInWaitingList(interval) {
      let size = this.signupListReviewsWaitList.filter(
        (sig) => sig.intervalId == interval.id
      ).length;
      return size;
    },
    fullInterval(interval) {
      return (
        this.signupsInInterval(interval) == this.limitOfParticipant(this.review)
      );
    },
    computedFields() {
      if (this.userStore.isAdmin)
        return this.fields.filter((field) => !field.onlyUsers);
      if (this.userStore.isTutor)
        return this.fields.filter((field) => !field.tutorOff);
      else return this.fields;
    },
    limitOfParticipantMethod(review) {
      if (review.type == "2") return review.maxParticipants;
      else if (review.type == "3") return review.participantsInInterval;
    },
    numOfSignupsInInterval(interval_id) {
      return this.signupListReviews.filter(
        (sig) => sig.intervalId == interval_id
      ).length;
    },
    addSelect(item, selected_list) {
      this.selected_users = selected_list;
    },
    vacancies(interval) {
      return (
        this.limitOfParticipant(this.review) - this.signupsInInterval(interval)
      );
    },
    // STARDRAG
    startDrag(event, item, index) {
      // Inicializar traspaso de informacion
      this.startSignupDrag = index;
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", JSON.stringify(item));
    },
    // DROPDRAG
    async dropIn(event, signup, item, index) {
      event.stopPropagation();
      event.preventDefault();
      // Recibir información desde el origen
      const droped = JSON.parse(event.dataTransfer.getData("text/plain"));

      // SI SE SUELTA EN LA MISMA POSICION NO HAGA NADA
      if (this.startSignupDrag !== null && this.startSignupDrag == index) {
        this.startSignupDrag = null;
        return;
      }
      // SI VIENE DE LA LISTA DE ESPERA
      if (droped.waitingList) {
        // si es depositado en lista de usuario
        if (signup == null) {
          this.$noty.error(this.$t("noty.error.not-change-wl"), {
            timeout: 3000,
            progressBar: true,
          });
          return;
        }
        // se quiere poner en otra franja
        if (droped.intervalId != signup.intervalId) {
          this.$noty.error(this.$t("noty.error.not-change"), {
            timeout: 3000,
            progressBar: true,
          });
          return;
        }
        // si el signup vine de la misma lista de espera
        // TODO - reordenar
        droped.orderInInterval = signup.orderInInterval;
        await ServiceSignup.putSignup(
          null,
          droped.intervalId,
          droped.id,
          droped
        ).then((response) => {
          if (response.status === 200) {
            this.$noty.success(this.$t("noty.success.change"), {
              timeout: 3000,
              progressBar: true,
            });
            this.reload = true;
          }
        });
      } else {
        // atajar el mover en la misma franja
        if (droped.intervalId == item.id) {
          this.startSignupDrag = null;
          return;
        }
        if (this.fullInterval(item)) {
          this.$noty.error(this.$t("noty.error.signuplist-full"), {
            timeout: 3000,
            progressBar: true,
          });
          return;
        }
        // si el signup viene de la lista de inscritos
        // TODO - pasar a lista de espera
        await ServiceSignup.putSignup(null, item.id, droped.id, droped).then(
          (response) => {
            if (response.status === 200) {
              this.reload = true;
            }
          }
        );
      }
      window.$("#signupwl-" + index).removeClass("drop-down-wl drop-up-wl");

      if (event.AT_TARGETdataTransfer.getData("text/plain"))
        event.AT_TARGETdataTransfer.clearData("text/plain");

      this.reloadIntervalTable();
    },
    //ENTER
    enterWlist(event, index) {
      event.stopPropagation();
      event.preventDefault();

      if (this.startSignupDrag > index) {
        window.$("#signupwl-" + index).addClass("drop-up-wl");
      } else if (this.startSignupDrag < index || this.startSignupDrag == null) {
        window.$("#signupwl-" + index).addClass("drop-down-wl");
      }
    },
    //LEAVE
    leaveWlist(event, index) {
      event.stopPropagation();
      event.preventDefault();
      window.$("#signupwl-" + index).removeClass("drop-down-wl drop-up-wl");
    },
    endDrag(event) {
      window.$("[id^=signupwl-]").removeClass("drop-down-wl drop-up-wl");
      this.startSignupDrag = null;
      if (event.AT_TARGETdataTransfer.getData("text/plain"))
        event.AT_TARGETdataTransfer.clearData("text/plain");
    },
  },
  computed: {
    options_users() {
      if (this.userStore.isStudent) return [];
      const groupsIds = this.review.groupList.map((group) => group.groupLmsId);
      const subscriptions = this.getSubscritionsOfReview();
      const usersInGroups = this.groupStore.getUsersInGroups(groupsIds);
      if (subscriptions.length === 0) {
        return usersInGroups;
      } else {
        const uniqueUsers = new Map();
        for (const user of usersInGroups) {
          const isSubscribed = subscriptions.some(
            (sub) => user.unirId == sub.userUnirId
          );
          if (!isSubscribed) {
            if (!uniqueUsers.has(user.unirId)) {
              uniqueUsers.set(user.unirId, user);
            }
          }
        }
        return Array.from(uniqueUsers.values());
      }
    },
    intervalState: () => {
      return (interval) => {
        let state;
        if (interval.canceled) {
          state = "canceled";
        } else if (interval.locked) {
          state = "locked";
        } else {
          state = "active";
        }
        return state;
      };
    },
    limitOfParticipant: () => {
      return (review) => {
        if (review.type == "2") return review.maxParticipants;
        else if (review.type == "3") return review.participantsInInterval;
      };
    },
  },
  watch: {
    reload: async function () {
      this.$emit("refreshtable");
    },
    userIsSubscribe: function (value) {
      this.$emit("changeSubcription", value);
    },
  },
};
</script>
